import { render, staticRenderFns } from "./ReceiveOrders.vue?vue&type=template&id=0d2a6835"
import script from "./ReceiveOrders.vue?vue&type=script&lang=js"
export * from "./ReceiveOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports